

































import { mapGetters } from 'vuex'
import { USER_NS } from '~/store/modules/shared//user/state'
import {
  adminTimeDistanceFromNow,
  format,
  timeDistanceFrom
} from '~/utils/date'
import AccountService from '~/services/account/AccountService'
import { formatNumber } from '~/utils/number'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    stateColor: {
      type: String,
      required: false,
      default: ''
    },
    parkedNumber: {
      type: [String, Number],
      required: false,
      default: 0
    },
    created: {
      type: String,
      required: false,
      default: null
    },
    modified: {
      type: String,
      required: false,
      default: null
    },
    views: {
      type: [String, Number],
      required: false,
      default: null
    },
    clicks: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    formattedCreatedDate() {
      return this.formatStatsDate(this.created)
    },
    formattedModifiedDate() {
      return this.formatStatsDate(this.modified)
    },
    stateText() {
      return this.$dep(AccountService).getStateTextForColor(this.stateColor)
    },
    formattedViews() {
      return formatNumber(this.views)
    },
    formattedClicks() {
      return formatNumber(this.clicks)
    },
    modifiedDateFull() {
      return format(this.modified, 'dd/MM/yyyy HH:mm')
    },
    createdDateFull() {
      return format(this.created, 'dd/MM/yyyy HH:mm')
    }
  },
  methods: {
    formatStatsDate(date: string) {
      if (this.userIsAdmin) {
        return adminTimeDistanceFromNow(new Date(date))
      } else {
        return timeDistanceFrom(date, new Date(), {
          locale: this.$i18n.locale,
          addSuffix: false,
          dateRelative: true,
          strict: true
        }).replace('ημέρες', 'μέρες')
      }
    }
  }
})
